interface Props {
  url: string
  text?: string
  emailSubject?: string
  type?: string
  fbappid?: string
}

export const getSharingUrl = (props): string => {
  const { url = '', text = '', emailSubject = '', fbappid = '', type = '' } = props
  const urlMap = {
    facebook: `https://www.facebook.com/dialog/share?app_id=${fbappid}&href=${url}`,
    twitter: `https://twitter.com/intent/tweet?url=${url}${text && `&text=${text}`}`,
    whatsApp: `https://api.whatsapp.com/send?text=${text ? `${text}%0A${url}` : url}`,
    email: `mailto:?subject=${emailSubject}&body=${text}%0A%0A${url}%0A%0A`,
  }

  return urlMap[type]
}
